import { Component, EventEmitter, Output } from '@angular/core';
import { SharedComponentsModule } from "../../../domain/shared/module/shared-components.module";

@Component({
  selector: 'app-modal-expired-session',
  standalone: true,
  imports: [
    SharedComponentsModule,
  ],
  templateUrl: './modal-expired-session.component.html',
  styleUrl: './modal-expired-session.component.scss',
})
export class ModalExpiredSessionComponent {
  @Output() goToLoginEmitter = new EventEmitter<void>();

  goToLogin(): void {
    this.goToLoginEmitter.emit();
  }
}
